import { Button } from '@salt/components';
import React, { useCallback } from 'react';
import { reinviteUser } from '../../api/users';

const ResendInviteModal = ({
  handleResendInviteModalClose,
  user,
  fetchData,
  setInviteLinkOpen,
}) => {
  const onReinvite = useCallback(() => {
    reinviteUser({ memberId: user.id })
      .then((res) => {
        setInviteLinkOpen(res.data?.inviteLink);
        fetchData();
      })
      .catch(() => {
        console.error('Failed to resend invite to user');
      });
    handleResendInviteModalClose();
  }, [user]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleResendInviteModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="text-lg mb-4">Resend Invite</div>
        <span className="text-base">
          Issue a new ninvite to <b>{user.username}</b>?
        </span>

        <div className="mt-4">
          <br />
          <Button
            onClick={handleResendInviteModalClose}
            type="neutral"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Cancel
          </Button>
          <Button
            onClick={onReinvite}
            type="positive"
            className="max-w-[146px] h-[36px] ml-auto float-right"
            paddingClassName="px-6"
          >
            Invite
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResendInviteModal;
